import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal, Tag } from 'antd';
import React, { use, useEffect, useState } from 'react';
import TestCaseList from './TestCaseList';
import { testCaseDifficultyMap } from './QuestionTab';
import styles from './QuestionTab.scss';

const QuestionDetails = ({
  question,
  testCases,
  onClose,
  tags,
  onAddQuestionTab,
  isAlreadyAdded,
}) => {
  let count = 0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hideQuestion, setHideQuestion] = useState(true);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    onAddQuestionTab(question, hideQuestion);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    setHideQuestion(true);
  }, [question]);
  const data = question.description
    ? question.description.split('\n').map(function (line) {
        if (
          line.includes('Input format') ||
          line.includes('Output format') ||
          line.includes('Constraints')
        ) {
          return (
            <div
              key={count++}
              className={styles['desc-style']}
            >
              {line}
            </div>
          );
        } else if (
          line.includes('Input:') ||
          line.includes('Output:') ||
          line.includes('Explanation:')
        ) {
          // srb remove them later
          return (
            <div
              key={count++}
              className={styles['desc-style']}
            >
              {line}
            </div>
          );
        } else {
          return (
            <div
              key={count++}
              className={styles['contentstyle']}
            >
              {line}
            </div>
          );
        }
      })
    : 'Please select a problem';
  return (
    <div
      style={{
        padding: 20,
        background: 'white',
        height: '70vh',
        overflowY: 'scroll',
        margin: 10,
        border: '1px solid #E6E6E6',
        boxShadow: '0px 0px 10px 0px #0000001A',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', gap: 12 }}>
          <p>{question.points} Points</p>
          <Tag style={{ height: 22 }}>Difficulty: {testCaseDifficultyMap[question.difficulty]}</Tag>
        </div>
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
          style={{ float: 'right' }}
        />
      </div>

      <div style={{ display: 'flex', marginTop: 20, justifyContent: 'space-between' }}>
        <h1 style={{ fontWeight: 500 }}>{question.title}</h1>
        <Button
          type="primary"
          onClick={showModal}
          disabled={isAlreadyAdded}
        >
          {isAlreadyAdded ? 'Added Already' : 'Add To Interview'}
        </Button>
      </div>
      <Modal
        title={<p style={{ fontSize: 24, textAlign: 'center' }}>Add to Interview</p>}
        centered
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <div
            key="footer"
            style={{ textAlign: 'center' }}
          >
            <Button
              key="cancel"
              onClick={handleCancel}
              style={{ marginRight: 8 }}
            >
              No
            </Button>
            <Button
              key="submit"
              type="primary"
              onClick={handleOk}
            >
              Yes
            </Button>
          </div>,
        ]}
      >
        <p style={{ textAlign: 'center' }}>Do you want to add this question to the interview?</p>
        <label
          style={{
            display: 'flex',
            margin: '-4px',
            marginTop: '4px',
            gap: 6,
            justifyContent: 'center',
          }}
        >
          <input
            type="checkbox"
            checked={hideQuestion}
            onChange={e => {
              setHideQuestion(e.target.checked);
            }}
          />
          Hide the question from candidate
        </label>
      </Modal>
      <div style={{ margin: '8px 0' }}>{data}</div>
      {testCases?.length > 0 && (
        <div className={styles['question-tab__testcases']}>
          <h3 className={styles['question-tab__desc']}>Test Cases :</h3>
          <TestCaseList testCases={testCases} />
        </div>
      )}
    </div>
  );
};

export default QuestionDetails;
